import React, { useState, useEffect, useRef } from 'react';
import './Profile.css';
import ElanCard from '../../components/ElanCard';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAllChats, updateChat, deleteChat } from '../../api/sifarish/SifarishController';
import ElanController from '../../api/elan/ElanController';
import UserController from '../../api/user/UserController';
import axios from 'axios';
import LotoreyaController from '../../api/lotoreya/LotoreyaController';
import moment from 'moment';
import 'moment/locale/az';

const Profile = () => {
  const [showEdit, setShowEdit] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');
  const [user, setUser] = useState(null);
  const [myElans, setMyElans] = useState([]);
  const [mySifarishler, setMySifarishler] = useState([]);
  const [showModal, setShowModal] = useState(false); // For showing the modal
  const navigate = useNavigate();
  const sifarishlerRef = useRef(null); // Reference to the "Moto Taksi Sifarişlərim" section
  const elanlarRef = useRef(null);
  const location = useLocation();
  const [balanceAmount, setBalanceAmount] = useState('');
  const [showBalanceForm, setShowBalanceForm] = useState(false);
  // State-lər
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingAmount, setPendingAmount] = useState(null);
  const [myLotoreyas, setMyLotoreyas] = useState([]);
  const [myBoughtLotoreyas, setMyBoughtLotoreyas] = useState([]);

  useEffect(() => {
    const userId = localStorage.getItem('motoTaksiUserId');
    if (userId) {
      UserController.getUserById(userId)
        .then(data => {
          setUser(data);
          ElanController.getElansByUserId(userId)
            .then(elans => {
              setMyElans(elans.reverse());

              // Lotoreyaları da yükləyək
              LotoreyaController.getAllLotoreyas()
                .then(allLotoreyas => {
                  const userLotoreyas = allLotoreyas.filter(l => l.userId === parseInt(userId));
                  setMyLotoreyas(userLotoreyas);
                })
                .catch(error => console.error('Lotoreyalar yüklənmədi:', error));
            })
            .catch(error => console.error('Elanlar yüklənmədi:', error));

          getAllChats()
            .then(allChats => {
              const userChats = allChats.filter(chat =>
                chat.userId === parseInt(userId) && chat.isWebsite === true
              );
              setMySifarishler(userChats.reverse());
            })
            .catch(error => console.error('Sifarişlər yüklənmədi:', error));
        })
        .catch(error => {
          console.error('İstifadəçi yüklənmədi:', error);
        });
    }
  }, []);

  useEffect(() => {
    const userId = localStorage.getItem('motoTaksiUserId');
    if (userId) {
      LotoreyaController.getAllLotoreyas()
        .then(async (allLotoreyas) => {
          const lotoreyasWithMyBilets = await Promise.all(allLotoreyas.map(async (lotoreya) => {
            try {
              let elan = null;
              try {
                elan = await ElanController.getElanById(lotoreya.elanId);
              } catch (elanErr) {
                console.warn(`Elan tapılmadı, ID = ${lotoreya.elanId}`);
              }

              // Burada userId uyğun biletləri tapırıq
              const myBilets = lotoreya.bilets?.filter(b => b.userId === parseInt(userId)) || [];

              if (myBilets.length > 0) {
                return {
                  ...lotoreya,
                  elan,
                  bilets: myBilets
                };
              } else {
                return null;
              }
            } catch (err) {
              console.error('Lotoreya və ya elan yüklənərkən xəta:', err);
              return null;
            }
          }));

          const filtered = lotoreyasWithMyBilets.filter(l => l !== null);

          // Set state
          setMyBoughtLotoreyas(filtered.reverse());
        })
        .catch(error => console.error('Lotoreyalar yüklənərkən xəta:', error));
    }
  }, []);

  // Scroll to the "Moto Taksi Sifarişlərim" section when navigating
  useEffect(() => {
    if (location.pathname === '/profile/sifarishlerim' && sifarishlerRef.current) {
      setTimeout(() => {
        window.scrollTo({
          top: sifarishlerRef.current.offsetTop,
          behavior: 'smooth',
        });
        setShowModal(true); // Scroll bitdikdən sonra modal göstərilir
      }, 500); // 500 ms timeout
    }
  }, [location.pathname, mySifarishler]); // Bu kod `sifarishlerRef` bölməsinə getdiyində işə düşəcək

  // Scroll to the "Moto Taksi Elanlarım" section when navigating to /profile/elanlarim
  useEffect(() => {
    if (location.pathname === '/profile/elanlarim' && elanlarRef.current) {
      setTimeout(() => {
        window.scrollTo({
          top: elanlarRef.current.offsetTop,
          behavior: 'smooth',
        });
      }, 500); // 500 ms timeout
    }
  }, [location.pathname]); // Bu kod yalnız /profile/elanlarim səhifəsində işləyəcək

  const handleToggleStatus = async (chat) => {
    try {
      const updated = { ...chat, isCompleted: !chat.isCompleted };
      await updateChat(chat.id, updated);

      setMySifarishler(prev =>
        prev.map(c => c.id === chat.id ? { ...c, isCompleted: !c.isCompleted } : c)
      );

      // Tamamlanmışsa, mesajı göstərmək
      if (!chat.isCompleted) {
        alert("Sifarişiniz tamamlandı!");
      }

    } catch (error) {
      console.error("Status dəyişdirilərkən xəta:", error);
      alert("Status dəyişdirilə bilmədi.");
    }
  };

  const handleDeleteSifarish = async (chatId) => {
    const confirmDelete = window.confirm("Bu sifarişi silmək istədiyinizə əminsiniz?");
    if (confirmDelete) {
      try {
        await deleteChat(chatId);
        setMySifarishler(prev => prev.filter(chat => chat.id !== chatId));
        // Tamamlanmışsa, mesajı göstərmək
        alert("Sifarişiniz silindi!");
      } catch (error) {
        console.error("Silinərkən xəta:", error);
        alert("Sifariş silinə bilmədi.");
      }
    }
  };

  const handleAddBalance = (e) => {
    e.preventDefault();

    const amount = parseFloat(balanceAmount);
    if (!amount || isNaN(amount) || amount < 1) {
      alert("Minimum balans artırma məbləği 1 AZN-dir.");
      return;
    }

    setPendingAmount(balanceAmount);
    setShowConfirmModal(true);
  };

  const handleConfirmedAddBalance = async () => {
    const userId = localStorage.getItem('motoTaksiUserId');

    try {
      const response = await axios.post('https://mototaksi.az:9898/api/v5/payment-init', {
        amount: parseFloat(pendingAmount),
        orderId: `balansmototaksiaz_${userId}_${Date.now()}`,
        description: 'Moto Taksi üçün balans artırılması',
        successUrl: `https://mototaksi.az/success?userId=${userId}&amount=${pendingAmount}&type=balansmototaksiaz`,
        errorUrl: `https://mototaksi.az/error`
      });

      const redirectUrl = response.data;

      if (redirectUrl) {
        // Form sahələrini təmizlə
        setBalanceAmount('');
        setPendingAmount(null);
        setShowConfirmModal(false);
        setShowBalanceForm(false);

        // 🔗 Yeni pəncərədə ödəniş səhifəsini aç
        window.open(redirectUrl, '_blank');
      } else {
        alert('Redirect link alınmadı.');
      }
    } catch (error) {
      console.error('Ödəniş səhifəsinə yönləndirilərkən xəta:', error);
      alert('Ödəniş səhifəsinə keçid mümkün olmadı.');
      setShowConfirmModal(false);
    }
  };

  const handlePasswordUpdate = (e) => {
    e.preventDefault();

    if (!oldPassword) {
      alert("Köhnə şifrəni daxil edin");
      return;
    }

    if (user.password !== oldPassword) {
      alert("Köhnə şifrə yanlışdır");
      return;
    }

    if (password !== confirm) {
      alert("Şifrələr uyğun deyil");
      return;
    }

    const updatedUser = { ...user, password: password };
    UserController.updateUser(user.id, updatedUser)
      .then((response) => {
        alert("Şifrə uğurla dəyişdirildi");
        setShowEdit(false);
        setOldPassword('');
        setPassword('');
        setConfirm('');
        setUser(response);
      })
      .catch(error => {
        console.error('Şifrə yenilənərkən xəta:', error);
        alert("Şifrə yenilənərkən xəta baş verdi");
      });
  };

  const handleLogout = () => {
    const confirmed = window.confirm('Çıxış etmək istədiyinizə əminsiniz?');
    if (confirmed) {
      localStorage.removeItem('motoTaksiUserId');
      window.location.href = '/auth';
    }
  };

  const filteredElans = activeCategory === 'all'
    ? myElans
    : myElans.filter(elan => elan.category === activeCategory);

  const handleElanClick = (elanId) => {
    navigate(`/elan/${elanId}`);
  };

  return (
    <div className="profile-container">
      {user ? (
        <div className="profile-card">
          <h2 className="profile-name">{user.name}</h2>
          <p className="profile-phone">{user.phoneNumber}</p>
          <p className="profile-email">{user.email}</p>

          {/* Yeni balans göstəricisi */}
          <div className="user-balance-display">
            Mövcud Balans:
            <span className="user-balance-amount">
              {(isNaN(user.balance) || user.balance == null ? 0 : user.balance).toFixed(2)} ₼
            </span>
          </div>

          <div className="balance-section">
            <button className="edit-btn" onClick={() => setShowBalanceForm(!showBalanceForm)}>
              {showBalanceForm ? 'Ləğv et' : 'Balans artır'}
            </button>

            {showBalanceForm && (
              <form className="balance-form" onSubmit={handleAddBalance}>
                <input
                  type="number"
                  min="1"
                  step="0.01"
                  placeholder="Məbləğ ₼"
                  value={balanceAmount}
                  onChange={(e) => setBalanceAmount(e.target.value)}
                  required
                />
                <button type="submit" className="save-btn">Təsdiqlə</button>
              </form>
            )}
          </div>

          <div className="profile-actions">
            <button className="edit-btn" onClick={() => setShowEdit(!showEdit)}>
              {showEdit ? 'Ləğv et' : 'Şifrəni dəyiş'}
            </button>
            <button className="logout-btn" onClick={handleLogout}>Çıxış</button>
          </div>

          {showEdit && (
            <form className="password-form" onSubmit={handlePasswordUpdate}>
              <input
                type="password"
                placeholder="Köhnə şifrə"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                required
              />
              <input
                type="password"
                placeholder="Yeni şifrə"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <input
                type="password"
                placeholder="Təsdiqlə"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
              />
              <button type="submit" className="save-btn">Yadda saxla</button>
            </form>
          )}

        </div>
      ) : (
        <div className="loading">İstifadəçi məlumatları yüklənir...</div>
      )}

      {myBoughtLotoreyas.length > 0 && (
        <div className="my-lotoreyas-section">
          <h3>Lotoreya Biletlərim</h3>

          {myBoughtLotoreyas.map(lotoreya => (
            <div key={lotoreya.id} className="lotoreya-card-bilets">
              <div className="lotoreya-header">
                <img
                  src={lotoreya.elan?.image}
                  alt={lotoreya.elan?.title}
                  className="lotoreya-header-image"
                />
                <div className="lotoreya-header-info">
                  <h4>{lotoreya.elan?.title}</h4>
                  <p>
                    Lotoreya Tarixi: {moment(lotoreya.lotoreyaDate).locale('az').format('D MMMM YYYY')}
                  </p>

                </div>
              </div>

              {lotoreya.carx ? (
                <div className="lotoreya-ended-message">
                  <p style={{ fontWeight: 'bold', fontSize: '16px', color: '#444' }}>
                    🎉 Lotoreya artıq başa çatıb.
                    {lotoreya.carx?.winnerBiletCode &&
                      lotoreya.bilets.some(b => b.code === lotoreya.carx.winnerBiletCode) ? (
                      <span style={{ color: 'green' }}> Siz QALİB oldunuz! ✅</span>
                    ) : (
                      <span style={{ color: 'red' }}> Təəssüf, qalib olmadınız. ❌</span>
                    )}
                  </p>
                </div>
              ) : (
                <div className="bilets-list">
  {lotoreya.bilets.map(bilet => {
    const isWinner = lotoreya.carx?.winnerBiletCode === bilet.code;

    return (
      <div key={bilet.id} className={`bilet-card ${isWinner ? 'winner-bilet' : 'loser-bilet'}`}>
        <p>
          <strong>Bilet Kodum:</strong> {bilet.code}{" "}
          {isWinner ? (
            <span style={{ color: 'green', fontWeight: 'bold' }}>✅ QALİB</span>
          ) : lotoreya.carx ? (
            <span style={{ color: 'red', fontWeight: 'bold' }}>❌ Təəssüf, qalib olmadınız.</span>
          ) : (
            <span style={{ color: 'orange', fontWeight: 'bold' }}>⏳ Gözlənir...</span>
          )}
        </p>
      </div>
    );
  })}
</div>

              )}

            </div>
          ))}
        </div>
      )}

      {mySifarishler.length > 0 && (
        <div ref={sifarishlerRef} className="my-sifarishler-section">
          <h3>Moto Taksi Sifarişlərim</h3>
          <div className="sifarish-list">
            {mySifarishler.map((chat) => (
              <div key={chat.id} className="sifarish-card">
                <p><strong>Mesaj:</strong> {chat.message}</p>
                <p className="sifarish-time">
                  {new Date(chat.timestamp).toLocaleString('az-AZ', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </p>
                <p className={`sifarish-status ${chat.isCompleted ? 'done' : 'pending'}`}>
                  {chat.isCompleted ? 'Tamamlanıb' : 'Gözləyir'}
                </p>

                <div className="sifarish-actions">
                  {!chat.isCompleted && (
                    <button onClick={() => handleToggleStatus(chat)} className="status-btn">
                      Tamamla
                    </button>
                  )}
                  <button onClick={() => handleDeleteSifarish(chat.id)} className="delete-btn">
                    Sil
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {showModal && location.pathname === '/profile/sifarishlerim' && (
        <div className="notification-modal">
          <div className="notification-content">
            <h4>Diqqət!</h4>
            <p>Aşağıda Sifarişlərinizə kuryer tapıldıqdan sonra sifarişi tamamlamağınız xahiş olunur. Əks halda kuryerlər sizi narahat edəcək.</p>
            <button className="close-btn" onClick={() => setShowModal(false)}>Aydındır</button>
          </div>
        </div>
      )}

      {showConfirmModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Diqqət!</h3>
            <p>Edilən ödənişlər bu saytda balansınızda olajax ancaq sayt daxilində istifade ede bileşsiniz ha yenədə davam edeşsinizmi? Qadan alaram</p>
            <div className="modal-actions">
              <button className="cancel-btn" onClick={() => setShowConfirmModal(false)}>Ləğv et</button>
              <button className="confirm-btn" onClick={handleConfirmedAddBalance}>Bəli, davam et</button>
            </div>
          </div>
        </div>
      )}

      <div ref={elanlarRef} className="my-elans-section">

        <h3>Elanlarım</h3>
        <div className="category-filter">
          <button onClick={() => setActiveCategory('all')}>Hamısı</button>
          <button onClick={() => setActiveCategory('taxi')}>Moto Taksi</button>
          <button onClick={() => setActiveCategory('sales')}>Alqı-Satqı</button>
          <button onClick={() => setActiveCategory('rent')}>Kirayə</button>
          <button onClick={() => setActiveCategory('spare')}>Zapçast</button>
        </div>

        <div className="elans-list-cards">
          {filteredElans.map((elan, index) => {
            // Elanın lotoreyada olub-olmamasını yoxlayırıq:
            const matchingLotoreya = myLotoreyas.find(l => l.elanId === elan.id);

            let lotoreyaStatus = null;
            if (matchingLotoreya) {
              if (matchingLotoreya.carx == null) {
                lotoreyaStatus = matchingLotoreya.isAccept ? 'accepted' : 'pending';
              } else {
                lotoreyaStatus = null; // çarx artıq fırlanıbsa status göstərilmir
              }
            }

            return (
              <ElanCard
                key={index}
                {...elan}
                lotoreyaStatus={lotoreyaStatus} // <== prop veririk
                onClick={() => handleElanClick(elan.id)}
              />
            );
          })}
        </div>

      </div>
    </div>
  );
};

export default Profile;

